export function getAblyApiKey() {
  if (process.env.VUE_APP_ABLY_API_KEY) {
    return process.env.VUE_APP_ABLY_API_KEY;
  }

  if (typeof window !== "undefined") {
    const storedKey = window.localStorage
      ? window.localStorage.getItem("ably_api_key")
      : null;
    if (storedKey) {
      return storedKey;
    }
  }

  return null;
}

/**
 * Extracts subdomain from baseURL
 * Examples:
 *   https://dev2.biyo.co -> dev2
 *   https://myclient.example.com -> myclient
 *   http://localhost:8000 -> localhost_8000
 *   http://localhost:8080 -> localhost_8080
 *
 * @param {string} baseUrl - The base URL (e.g., "https://dev2.biyo.co")
 * @returns {string} - The extracted subdomain (never falls back to "store")
 * @throws {Error} - If baseUrl is missing or cannot be parsed
 */
export function extractSubdomainFromBaseUrl(baseUrl) {
  if (!baseUrl) {
    throw new Error(
      "[RealtimeConfig] baseUrl is required to extract subdomain"
    );
  }

  try {
    const url = new URL(baseUrl);
    const hostname = url.hostname;
    const port = url.port;

    const parts = hostname.split(".");

    if (hostname === "localhost" && port) {
      return `localhost_${port}`;
    }

    if (parts.length >= 3) {
      return parts[0].toLowerCase();
    } else if (parts.length === 2) {
      if (parts[0] === "localhost") {
        return port ? `localhost_${port}` : "localhost";
      }
      return parts[0].toLowerCase();
    } else if (parts.length === 1) {
      if (parts[0] === "localhost") {
        return port ? `localhost_${port}` : "localhost";
      }
      return parts[0].toLowerCase();
    } else {
      throw new Error(
        `[RealtimeConfig] Unable to extract subdomain from hostname: ${hostname}`
      );
    }
  } catch (error) {
    if (error.message && error.message.includes("[RealtimeConfig]")) {
      throw error;
    }
    throw new Error(
      `[RealtimeConfig] Failed to parse baseURL "${baseUrl}": ${error.message}`
    );
  }
}
